/**
 * Created by wjjn3481 on 2017/4/24.
 */
import Vue from 'vue'

const state = {
    menu: []
}

const mutations = {
    APP_IN (state, app) {
        Object.assign(state, app)
    },

    APP_OUT (state) {
        Object.keys(state).forEach(key => Vue.delete(state, key))
    }
}

export default {
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js